import React, { useState, useEffect } from 'react';
import ChartOrderBook from './ChartOrderBook';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartOrderBookData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartOrderBookData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartOrderBookData = () => {
  const [dataSet, setDataSet] = useState('dataOrderBook');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartOrderBook data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartOrderBookData;
